(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('ApplicationFeatureDialogController', ApplicationFeatureDialogController);

    ApplicationFeatureDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationFeature'];

    function ApplicationFeatureDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationFeature) {
        var vm = this;

        vm.applicationFeature = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationFeature.id !== null) {
                ApplicationFeature.update(vm.applicationFeature, onSaveSuccess, onSaveError);
            } else {
                ApplicationFeature.save(vm.applicationFeature, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:applicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
